import * as React from 'react'
import { cn } from '@utils';

const MiddleColumnLayout = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
	({ className, ...props }, ref) => (
		<div ref={ref} className={cn('flex justify-center', className)} data-testid="middle-Column-layout" {...props}>
			<div className="w-11/12 md:w-10/12 lg:w-6/12">{props.children}</div>
		</div>
	)
);
MiddleColumnLayout.displayName = 'MiddleColumnLayout';
export { MiddleColumnLayout };
